/**
 * A choice remembered on this device, the one way a foundation piece keeps one. A window that cannot store (a private
 * window, blocked site data) reads nothing and writes nothing, and the caller keeps the choice for the visit.
 */

export function readDeviceChoice(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeDeviceChoice(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* Kept for the visit by the caller. */
  }
}

/** This device's storage for the one module that keeps more than a word in it (the push device's id), or null. */
export function deviceChoiceStorage(): Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** A choice remembered for this browser tab, for a screen's first draw. A tab that cannot store reads nothing. */
export function readTabChoice(key: string): string | null {
  try {
    return globalThis.sessionStorage?.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function writeTabChoice(key: string, value: string): void {
  try {
    globalThis.sessionStorage?.setItem(key, value);
  } catch {
    /* The choice lasts while the screen is open. */
  }
}
